/*@ngInject*/
const UIUploadDirective = function (coreConstant) {

        var linkFunction = function ($scope, element, $attrs) {

            var delegateToParent = !_.isNil($attrs.uiUploadDelegateToParent);

            function handleClick(e) {
                var target = $(e.target);

                if (delegateToParent) {
                    target = target.parent();
                }

                target.siblings('.hiddenUpload').trigger('click');
            }

        element.bind('click', handleClick);

        $scope.$on('$destroy', function () {
            element.unbind('click', handleClick);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiUpload', UIUploadDirective);
